export default "__VITE_ASSET__gMxrAKzF__"